// extracted by mini-css-extract-plugin
export var blue = "PerkIcon-module--blue--db9f4";
export var green = "PerkIcon-module--green--343dc";
export var icon = "PerkIcon-module--icon--75ee7";
export var neutral = "PerkIcon-module--neutral--969cd";
export var orange = "PerkIcon-module--orange--e407d";
export var purple = "PerkIcon-module--purple--f8b04";
export var yellow = "PerkIcon-module--yellow--4ec38";